
import React, { useEffect, useState } from 'react';
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Box,
  Grid,
  FormControl, InputLabel, Select, IconButton
} from '@mui/material';
import axios from 'axios';
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices"
import showTimeServices from "../../services/externalServices/TicketServices/showTimeServices"
import clapperboardIcon from '../../../assets/images/film-slate.png'
import timeIcon from '../../../assets/images/timetable.png'
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete'
import moment from 'moment';





// const AddValidity = () => {
//   const [theatres, setTheatres] = useState([]);
//   const [filteredMovies, setFilteredMovies] = useState([]);
//   const [selectedTheatre, setSelectedTheatre] = useState('');
//   const [selectedMovie, setSelectedMovie] = useState('');
//   const [selectedMovieLanguages, setSelectedMovieLanguages] = useState([]);
//   const [validityFrom, setValidityFrom] = useState('');
//   const [validityUntil, setValidityUntil] = useState('');
//   const [showtimes, setShowtimes] = useState([{ hour: '', minute: '', period: '', language: '', format: '' }]);
//   const [isReadyForBooking, setIsReadyForBooking] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [isLoadingMovies, setIsLoadingMovies] = useState(false);

//   const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
//   const isTicketAdmin = role === 'ticket-admin';

//   useEffect(() => {
//     const fetchTheatres = async () => {
//       try {
//         const theatresRes = await TheatreServices.getTheatres();
//         let filtered = theatresRes;
//         if (isTicketAdmin) {
//           filtered = theatresRes.filter(t => accessList.includes(t.name));
//         }
//         setTheatres(filtered);

//         if (filtered.length > 0) {
//           const defaultTheatre = filtered[0];
//           setSelectedTheatre(defaultTheatre.name);
//           handleTheatreChangeById(defaultTheatre._id);
//         }
//       } catch (err) {
//         console.error("Error fetching theatres:", err);
//       }
//     };
//     fetchTheatres();
//   }, []);

//   const handleTheatreChange = (e) => {
//     const theatreName = e.target.value;
//     setSelectedTheatre(theatreName);
//     setSelectedMovie('');
//     setSelectedMovieLanguages([]);
//     const theatreId = theatres.find(t => t.name === theatreName)?._id;
//     if (theatreId) handleTheatreChangeById(theatreId);
//   };

//   const handleTheatreChangeById = async (theatreId) => {
//     try {
//       setIsLoadingMovies(true);
//       const res = await MovieServices.getMovieByTheaterId(theatreId);


//       console.log('res in the movie', res);

//       setFilteredMovies(res || []);
//     } catch (err) {
//       console.error("Error fetching movies:", err);
//       setFilteredMovies([]);
//     } finally {
//       setIsLoadingMovies(false);
//     }
//   };

// //   useEffect(() => {
// //     console.log('Selected movie ID:', selectedMovie);
// //     console.log('All filtered movies:', filteredMovies);

// //     const selected = filteredMovies.find(movie => String(movie._id) === String(selectedMovie));
// //     console.log('Matched selected movie:', selected);

// //     setSelectedMovieLanguages(selected?.movieLanguages || ["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"]);
// //   }, [selectedMovie, filteredMovies]);


// //   useEffect(() => {
// //     if (!selectedMovie || filteredMovies.length === 0) return;

// //     const selected = filteredMovies.find(movie => String(movie._id) === String(selectedMovie));


// //     console.log("Matched selected movie:", selected);

// //     setSelectedMovieLanguages(
// //       selected?.movieLanguages || ["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"]
// //     );
// //   }, [selectedMovie, filteredMovies]);


//   useEffect(() => {
//     if (!selectedMovie || filteredMovies.length === 0) return;

//     const selected = filteredMovies.find(movie => movie.name === selectedMovie);
//     console.log("Matched selected movie:", selected);

//     setSelectedMovieLanguages(
//       selected?.movieLanguages || ["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"]
//     );
//   }, [selectedMovie, filteredMovies]);





//   const handleShowtimeChange = (index, e) => {
//     const { name, value } = e.target;
//     const updated = [...showtimes];
//     updated[index][name] = value;
//     setShowtimes(updated);
//   };

//   const addShowtime = () => {
//     setShowtimes([...showtimes, { hour: '', minute: '', period: '', language: '', format: '' }]);
//   };

//   const removeShowtime = (index) => {
//     const updated = showtimes.filter((_, i) => i !== index);
//     setShowtimes(updated);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitted(true);

//     console.log('selectedMovie=====================', selectedMovie);

//     const data = {
//       movieName: selectedMovie,
//       validityFrom: new Date(validityFrom).toISOString(),
//       validityUntil: new Date(validityUntil).toISOString(),
//       theatreShowtimes: [
//         {
//           theatreName: selectedTheatre,
//           isReadyForBooking,
//           shows: showtimes.map(({ hour, minute, period, language, format }) => ({
//             time: `${hour}:${minute} ${period}`,
//             language,
//             format
//           }))
//         }
//       ]
//     };

//     console.log('selected Theater', data);

//     try {
//       const response = await showTimeServices.createShowtime(data);


//       if (response?.data) {
//         alert('Successfully added showtime');
//         resetForm();
//       } else {
//         handleError(response);
//       }
//     } catch (err) {
//       console.error("Submit error:", err);
//       alert('Something went wrong!');
//       resetForm();
//     }
//   };

//   const handleError = (response) => {
//     const msg = response.error?.message || response.message || response.error;
//     if (msg.includes('cannot be booked today')) {
//       const match = msg.match(/valid (.*?) to (.*?)\)/);
//       if (match) {
//         alert(`⚠️ Can only be booked between ${match[1]} and ${match[2]}`);
//       } else alert(msg);
//     } else if (msg.includes('Showtime already exists')) {
//       const nameMatch = msg.match(/movie \\"(.+?)\\"/);
//       alert(`❌ Showtime already exists for ${nameMatch?.[1] || 'this movie'}`);
//     } else alert("❌ " + msg);
//     resetForm();
//   };

//   const resetForm = () => {
//     setSelectedMovie('');
//     setValidityFrom('');
//     setValidityUntil('');
//     setShowtimes([{ hour: '', minute: '', period: '', language: '', format: '' }]);
//     setSubmitted(false);
//     setIsReadyForBooking(false);
//   };

//   return (
//     <div className="min-h-screen p-6 max-w-4xl mx-auto">
//       <div className="flex items-center mb-8">
//         <img src={timeIcon} alt="Time" className="w-8 h-8 mr-3" />
//         <h1 className="text-2xl font-bold text-gray-800">Set Movie Validity Schedule</h1>
//       </div>

//       <form onSubmit={handleSubmit} className="space-y-6">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {/* Theatre */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Theatre</label>
//             <select
//               value={selectedTheatre}
//               onChange={handleTheatreChange}
//               disabled={isTicketAdmin}
//               required
//               className="w-full p-2 border rounded-md"
//             >
//               {isTicketAdmin ? (
//                 <option value={theatres[0]?.name}>{theatres[0]?.name}</option>
//               ) : (
//                 <>
//                   <option value="">Select Theatre</option>
//                   {theatres.map(t => (
//                     <option key={t._id} value={t.name}>{t.name}</option>
//                     // <option key={m._id} value={m.name}>{m.name}</option>

//                   ))}
//                 </>
//               )}
//             </select>
//           </div>

//           {/* Movie */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Movie</label>
//             {isLoadingMovies ? (
//               <div className="p-2 border rounded-md bg-gray-100 text-gray-500">Loading movies...</div>
//             ) : (
//               <select
//                 value={selectedMovie}
//                 onChange={(e) => setSelectedMovie(e.target.value)}
//                 disabled={!selectedTheatre}
//                 required
//                 className="w-full p-2 border rounded-md"
//               >
//                 <option value="">Select Movie</option>
//                 {filteredMovies.map(m => (
//                     // <option key={String(m._id)} value={String(m._id)}>{m.name}</option>

//                     <option key={m._id} value={m.name}>{m.name}</option>
//                 ))}
//               </select>
//             )}
//           </div>

//           {/* Dates */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700">From</label>
//             <input
//               type="date"
//               value={validityFrom}
//               onChange={(e) => setValidityFrom(e.target.value)}
//               required
//               className="w-full p-2 border rounded-md"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Until</label>
//             <input
//               type="date"
//               value={validityUntil}
//               onChange={(e) => setValidityUntil(e.target.value)}
//               required
//               className="w-full p-2 border rounded-md"
//             />
//           </div>
//         </div>

//         {/* Showtimes */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-2">Show Times</label>
//           {showtimes.map((s, index) => (
//             <div key={index} className="flex gap-2 mb-2">
//               {["hour", "minute", "period", "language", "format"].map((field, i) => (
//                 <select
//                   key={field}
//                   name={field}
//                   value={s[field]}
//                   onChange={(e) => handleShowtimeChange(index, e)}
//                   required
//                   className="p-2 border rounded-md"
//                 >
//                   {field === "hour" && [...Array(12).keys()].map(i => (
//                     <option key={i} value={String(i + 1).padStart(2, '0')}>{String(i + 1).padStart(2, '0')}</option>
//                   ))}
//                   {field === "minute" && [...Array(60).keys()].map(i => (
//                     <option key={i} value={String(i).padStart(2, '0')}>{String(i).padStart(2, '0')}</option>
//                   ))}
//                   {field === "period" && ["AM", "PM"].map(p => <option key={p} value={p}>{p}</option>)}
//                   {field === "language" && selectedMovieLanguages.map(l => <option key={l} value={l}>{l}</option>)}
//                   {field === "format" && ["2D", "3D"].map(f => <option key={f} value={f}>{f}</option>)}
//                   <option value="">{field[0].toUpperCase() + field.slice(1)}</option>
//                 </select>
//               ))}
//               <button
//                 type="button"
//                 onClick={() => index === 0 ? addShowtime() : removeShowtime(index)}
//                 className={`p-2 text-white rounded-md ${index === 0 ? 'bg-green-600' : 'bg-red-600'}`}
//               >
//                 {index === 0 ? '+' : '-'}
//               </button>
//             </div>
//           ))}
//         </div>

//         {/* Booking Checkbox */}
//         <div className="flex items-center">
//           <input
//             type="checkbox"
//             checked={isReadyForBooking}
//             onChange={(e) => setIsReadyForBooking(e.target.checked)}
//             className="mr-2"
//           />
//           <label>Ready for Booking Immediately</label>
//         </div>

//         <button
//           type="submit"
//           disabled={submitted}
//           className={`w-full py-2 text-white rounded-md ${submitted ? 'bg-gray-400' : 'bg-black hover:bg-gray-800'}`}
//         >
//           {submitted ? 'Submitting...' : 'Submit Schedule'}
//         </button>
//       </form>
//     </div>
//   );
// };









// const AddValidity = () => {
//   const [theatres, setTheatres] = useState([]);
//   const [filteredMovies, setFilteredMovies] = useState([]);
//   const [selectedTheatre, setSelectedTheatre] = useState('');
//   const [selectedMovie, setSelectedMovie] = useState('');
//   const [selectedMovieLanguages, setSelectedMovieLanguages] = useState([]);
//   const [validityFrom, setValidityFrom] = useState('');
//   const [validityUntil, setValidityUntil] = useState('');
//   const [showtimes, setShowtimes] = useState([
//     { hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }
//   ]);
//   const [isReadyForBooking, setIsReadyForBooking] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [isLoadingMovies, setIsLoadingMovies] = useState(false);
//   const [datePickerOpen, setDatePickerOpen] = useState(null);

//   const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
//   const isTicketAdmin = role === 'ticket-admin';

//   useEffect(() => {
//     const fetchTheatres = async () => {
//       try {
//         const theatresRes = await TheatreServices.getTheatres();
//         let filtered = theatresRes;
//         if (isTicketAdmin) {
//           filtered = theatresRes.filter(t => accessList.includes(t.name));
//         }
//         setTheatres(filtered);

//         if (filtered.length > 0) {
//           const defaultTheatre = filtered[0];
//           setSelectedTheatre(defaultTheatre.name);
//           handleTheatreChangeById(defaultTheatre._id);
//         }
//       } catch (err) {
//         console.error("Error fetching theatres:", err);
//       }
//     };
//     fetchTheatres();
//   }, []);

//   const handleTheatreChange = (e) => {
//     const theatreName = e.target.value;
//     setSelectedTheatre(theatreName);
//     setSelectedMovie('');
//     setSelectedMovieLanguages([]);
//     const theatreId = theatres.find(t => t.name === theatreName)?._id;
//     if (theatreId) handleTheatreChangeById(theatreId);
//   };

//   const handleTheatreChangeById = async (theatreId) => {
//     try {
//       setIsLoadingMovies(true);
//       const res = await MovieServices.getMovieByTheaterId(theatreId);
//       setFilteredMovies(res || []);
//     } catch (err) {
//       console.error("Error fetching movies:", err);
//       setFilteredMovies([]);
//     } finally {
//       setIsLoadingMovies(false);
//     }
//   };

//   useEffect(() => {
//     if (!selectedMovie || filteredMovies.length === 0) return;
//     const selected = filteredMovies.find(movie => movie.name === selectedMovie);
//     setSelectedMovieLanguages(
//       selected?.movieLanguages || ["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"]
//     );
//   }, [selectedMovie, filteredMovies]);

//   const handleShowtimeChange = (index, e) => {
//     const { name, value } = e.target;
//     const updated = [...showtimes];
//     updated[index][name] = value;
//     setShowtimes(updated);
//   };

//   const addShowtime = () => {
//     setShowtimes([...showtimes, { hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }]);
//   };

//   const removeShowtime = (index) => {
//     const updated = showtimes.filter((_, i) => i !== index);
//     setShowtimes(updated);
//   };

//   const handleDateSelection = (index, dates) => {
//     const updated = [...showtimes];
//     updated[index].enabledDates = dates.map(date => formatDate(date));
//     setShowtimes(updated);
//   };

//   const formatDate = (date) => {
//     const d = new Date(date);
//     return d.toISOString().split('T')[0];
//   };

//   const getAllDatesInRange = () => {
//     if (!validityFrom || !validityUntil) return [];

//     const start = new Date(validityFrom);
//     const end = new Date(validityUntil);
//     const dates = [];

//     let current = new Date(start);
//     while (current <= end) {
//       dates.push(new Date(current));
//       current.setDate(current.getDate() + 1);
//     }

//     return dates;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitted(true);

//     const data = {
//       movieName: selectedMovie,
//       validityFrom: new Date(validityFrom).toISOString(),
//       validityUntil: new Date(validityUntil).toISOString(),
//       theatreShowtimes: [
//         {
//           theatreName: selectedTheatre,
//           isReadyForBooking,
//           shows: showtimes.map(({ hour, minute, period, language, format, enabledDates }) => ({
//             time: `${hour}:${minute} ${period}`,
//             language,
//             format,
//             enabledDates: enabledDates || []
//           }))
//         }
//       ]
//     };


//     console.log('data in the response ===============', data);

//     try {
//       const response = await showTimeServices.createShowtime(data);
//       if (response?.data) {
//         alert('✅ Successfully added showtime');
//         resetForm();
//       } else {
//         handleError(response);
//       }
//     } catch (err) {
//       console.error("Submit error:", err);
//       alert('❌ Something went wrong!');
//       resetForm();
//     }
//   };

//   const handleError = (response) => {
//     const msg = response.error?.message || response.message || response.error;
//     if (msg.includes('cannot be booked today')) {
//       const match = msg.match(/valid (.*?) to (.*?)\)/);
//       if (match) {
//         alert(`⚠️ Can only be booked between ${match[1]} and ${match[2]}`);
//       } else alert(msg);
//     } else if (msg.includes('Showtime already exists')) {
//       const nameMatch = msg.match(/movie \\"(.+?)\\"/);
//       alert(`❌ Showtime already exists for ${nameMatch?.[1] || 'this movie'}`);
//     } else alert("❌ " + msg);
//     resetForm();
//   };

//   const resetForm = () => {
//     setSelectedMovie('');
//     setValidityFrom('');
//     setValidityUntil('');
//     setShowtimes([{ hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }]);
//     setSubmitted(false);
//     setIsReadyForBooking(false);
//   };

//   const DatePickerModal = ({ index, onClose, onSave }) => {
//     const [selectedDates, setSelectedDates] = useState([...showtimes[index].enabledDates]);

//     const toggleDate = (date) => {
//       const dateStr = formatDate(date);
//       setSelectedDates(prev => 
//         prev.includes(dateStr) 
//           ? prev.filter(d => d !== dateStr)
//           : [...prev, dateStr]
//       );
//     };

//     const allDates = getAllDatesInRange();

//     return (
//       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//         <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
//           <h3 className="text-lg font-bold mb-4">Select Enabled Dates</h3>
//           <div className="grid grid-cols-7 gap-1 mb-4">
//             {allDates.map((date, idx) => {
//               const dateStr = formatDate(date);
//               const isSelected = selectedDates.includes(dateStr);
//               return (
//                 <button
//                   key={idx}
//                   onClick={() => toggleDate(date)}
//                   className={`p-2 border rounded ${isSelected ? 'bg-blue-500 text-white' : 'bg-white'}`}
//                 >
//                   {date.getDate()}
//                   <div className="text-xs">{date.toLocaleString('default', { month: 'short' })}</div>
//                 </button>
//               );
//             })}
//           </div>
//           <div className="flex justify-end gap-2">
//             <button 
//               onClick={onClose}
//               className="px-4 py-2 bg-gray-300 rounded"
//             >
//               Cancel
//             </button>
//             <button 
//               onClick={() => onSave(selectedDates)}
//               className="px-4 py-2 bg-blue-500 text-white rounded"
//             >
//               Save
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen p-6 max-w-4xl mx-auto">
//       <h1 className="text-2xl font-bold mb-6">Set Movie Validity Schedule</h1>

//       <form onSubmit={handleSubmit} className="space-y-6">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Theatre</label>
//             <select
//               value={selectedTheatre}
//               onChange={handleTheatreChange}
//               disabled={isTicketAdmin}
//               required
//               className="w-full p-2 border rounded-md"
//             >
//               {isTicketAdmin ? (
//                 <option value={theatres[0]?.name}>{theatres[0]?.name}</option>
//               ) : (
//                 <>
//                   <option value="">Select Theatre</option>
//                   {theatres.map(t => (
//                     <option key={t._id} value={t.name}>{t.name}</option>
//                   ))}
//                 </>
//               )}
//             </select>
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700">Movie</label>
//             {isLoadingMovies ? (
//               <div className="p-2 border rounded-md bg-gray-100 text-gray-500">Loading movies...</div>
//             ) : (
//               <select
//                 value={selectedMovie}
//                 onChange={(e) => setSelectedMovie(e.target.value)}
//                 disabled={!selectedTheatre}
//                 required
//                 className="w-full p-2 border rounded-md"
//               >
//                 <option value="">Select Movie</option>
//                 {filteredMovies.map(m => (
//                   <option key={m._id} value={m.name}>{m.name}</option>
//                 ))}
//               </select>
//             )}
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700">From</label>
//             <input
//               type="date"
//               value={validityFrom}
//               onChange={(e) => setValidityFrom(e.target.value)}
//               required
//               className="w-full p-2 border rounded-md"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Until</label>
//             <input
//               type="date"
//               value={validityUntil}
//               onChange={(e) => setValidityUntil(e.target.value)}
//               required
//               className="w-full p-2 border rounded-md"
//             />
//           </div>
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-2">Show Times</label>
//           {showtimes.map((s, index) => (
//             <div key={index} className="flex flex-wrap items-center gap-2 mb-3">
//               {["hour", "minute", "period", "language", "format"].map((field) => (
//                 <select
//                   key={field}
//                   name={field}
//                   value={s[field]}
//                   onChange={(e) => handleShowtimeChange(index, e)}
//                   required
//                   className="p-2 border rounded-md"
//                 >
//                   <option value="">{field[0].toUpperCase() + field.slice(1)}</option>
//                   {field === "hour" && [...Array(12).keys()].map(i => (
//                     <option key={i} value={String(i + 1).padStart(2, '0')}>{String(i + 1).padStart(2, '0')}</option>
//                   ))}
//                   {field === "minute" && [...Array(60).keys()].map(i => (
//                     <option key={i} value={String(i).padStart(2, '0')}>{String(i).padStart(2, '0')}</option>
//                   ))}
//                   {field === "period" && ["AM", "PM"].map(p => <option key={p} value={p}>{p}</option>)}
//                   {field === "language" && selectedMovieLanguages.map(l => <option key={l} value={l}>{l}</option>)}
//                   {field === "format" && ["2D", "3D"].map(f => <option key={f} value={f}>{f}</option>)}
//                 </select>
//               ))}

//               <div className="flex flex-col">
//                 <button
//                   type="button"
//                   onClick={() => setDatePickerOpen(index)}
//                   className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200"
//                   style={{ width: '240px' }}
//                 >
//                   {s.enabledDates.length > 0 
//                     ? `${s.enabledDates.length} dates selected` 
//                     : "Select dates"}
//                 </button>
//                 <small className="text-gray-500">
//                   {s.enabledDates.length > 0 ? s.enabledDates.join(', ') : 'Click to select dates'}
//                 </small>
//               </div>

//               <button
//                 type="button"
//                 onClick={() => index === 0 ? addShowtime() : removeShowtime(index)}
//                 className={`p-2 text-white rounded-md ${index === 0 ? 'bg-green-600' : 'bg-red-600'}`}
//               >
//                 {index === 0 ? '+' : '-'}
//               </button>
//             </div>
//           ))}
//         </div>

//         <div className="flex items-center">
//           <input
//             type="checkbox"
//             checked={isReadyForBooking}
//             onChange={(e) => setIsReadyForBooking(e.target.checked)}
//             className="mr-2"
//           />
//           <label>Ready for Booking Immediately</label>
//         </div>

//         <button
//           type="submit"
//           disabled={submitted}
//           className={`w-full py-2 text-white rounded-md ${submitted ? 'bg-gray-400' : 'bg-black hover:bg-gray-800'}`}
//         >
//           {submitted ? 'Submitting...' : 'Submit Schedule'}
//         </button>
//       </form>

//       {datePickerOpen !== null && (
//         <DatePickerModal
//           index={datePickerOpen}
//           onClose={() => setDatePickerOpen(null)}
//           onSave={(dates) => {
//             handleDateSelection(datePickerOpen, dates);
//             setDatePickerOpen(null);
//           }}
//         />
//       )}
//     </div>
//   );
// };





// export default AddValidity;












// const AddValidity = () => {
//   const [theatres, setTheatres] = useState([]);
//   const [filteredMovies, setFilteredMovies] = useState([]);
//   const [selectedTheatre, setSelectedTheatre] = useState('');
//   const [selectedMovie, setSelectedMovie] = useState('');
//   const [selectedMovieLanguages, setSelectedMovieLanguages] = useState([]);
//   const [validityFrom, setValidityFrom] = useState('');
//   const [validityUntil, setValidityUntil] = useState('');
//   const [showtimes, setShowtimes] = useState([
//     { hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] } // Empty array means all dates enabled
//   ]);
//   const [isReadyForBooking, setIsReadyForBooking] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [isLoadingMovies, setIsLoadingMovies] = useState(false);
//   const [datePickerOpen, setDatePickerOpen] = useState(null);

//   const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
//   const isTicketAdmin = role === 'ticket-admin';

//   useEffect(() => {
//     const fetchTheatres = async () => {
//       try {
//         const theatresRes = await TheatreServices.getTheatres();
//         let filtered = theatresRes;
//         if (isTicketAdmin) {
//           filtered = theatresRes.filter(t => accessList.includes(t.name));
//         }
//         setTheatres(filtered);

//         if (filtered.length > 0) {
//           const defaultTheatre = filtered[0];
//           setSelectedTheatre(defaultTheatre.name);
//           handleTheatreChangeById(defaultTheatre._id);
//         }
//       } catch (err) {
//         console.error("Error fetching theatres:", err);
//       }
//     };
//     fetchTheatres();
//   }, []);

//   const handleTheatreChange = (e) => {
//     const theatreName = e.target.value;
//     setSelectedTheatre(theatreName);
//     setSelectedMovie('');
//     setSelectedMovieLanguages([]);
//     const theatreId = theatres.find(t => t.name === theatreName)?._id;
//     if (theatreId) handleTheatreChangeById(theatreId);
//   };

//   const handleTheatreChangeById = async (theatreId) => {
//     try {
//       setIsLoadingMovies(true);
//       const res = await MovieServices.getMovieByTheaterId(theatreId);
//       setFilteredMovies(res || []);
//     } catch (err) {
//       console.error("Error fetching movies:", err);
//       setFilteredMovies([]);
//     } finally {
//       setIsLoadingMovies(false);
//     }
//   };

//   useEffect(() => {
//     if (!selectedMovie || filteredMovies.length === 0) return;
//     const selected = filteredMovies.find(movie => movie.name === selectedMovie);
//     setSelectedMovieLanguages(
//       selected?.movieLanguages || ["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"]
//     );
//   }, [selectedMovie, filteredMovies]);

//   const handleShowtimeChange = (index, e) => {
//     const { name, value } = e.target;
//     const updated = [...showtimes];
//     updated[index][name] = value;
//     setShowtimes(updated);
//   };

//   const addShowtime = () => {
//     setShowtimes([...showtimes, { hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }]);
//   };

//   const removeShowtime = (index) => {
//     const updated = showtimes.filter((_, i) => i !== index);
//     setShowtimes(updated);
//   };

//   const handleDateSelection = (index, dates) => {
//     const updated = [...showtimes];
//     updated[index].enabledDates = dates;
//     setShowtimes(updated);
//   };

//   const formatDate = (date) => {
//     const d = new Date(date);
//     return d.toISOString().split('T')[0];
//   };

//   const getAllDatesInRange = () => {
//     if (!validityFrom || !validityUntil) return [];

//     const start = new Date(validityFrom);
//     const end = new Date(validityUntil);
//     const dates = [];

//     let current = new Date(start);
//     while (current <= end) {
//       dates.push(new Date(current));
//       current.setDate(current.getDate() + 1);
//     }

//     return dates;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitted(true);

//     const data = {
//       movieName: selectedMovie,
//       validityFrom: new Date(validityFrom).toISOString(),
//       validityUntil: new Date(validityUntil).toISOString(),
//       theatreShowtimes: [
//         {
//           theatreName: selectedTheatre,
//           isReadyForBooking,
//           shows: showtimes.map(({ hour, minute, period, language, format, enabledDates }) => ({
//             time: `${hour}:${minute} ${period}`,
//             language,
//             format,
//             enabledDates // Empty array means all dates are enabled
//           }))
//         }
//       ]
//     };

//     try {
//       const response = await showTimeServices.createShowtime(data);
//       if (response?.data) {
//         alert('✅ Successfully added showtime');
//         resetForm();
//       } else {
//         handleError(response);
//       }
//     } catch (err) {
//       console.error("Submit error:", err);
//       alert('❌ Something went wrong!');
//       resetForm();
//     }
//   };

//   const handleError = (response) => {
//     const msg = response.error?.message || response.message || response.error;
//     if (msg.includes('cannot be booked today')) {
//       const match = msg.match(/valid (.*?) to (.*?)\)/);
//       if (match) {
//         alert(`⚠️ Can only be booked between ${match[1]} and ${match[2]}`);
//       } else alert(msg);
//     } else if (msg.includes('Showtime already exists')) {
//       const nameMatch = msg.match(/movie \\"(.+?)\\"/);
//       alert(`❌ Showtime already exists for ${nameMatch?.[1] || 'this movie'}`);
//     } else alert("❌ " + msg);
//     resetForm();
//   };

//   const resetForm = () => {
//     setSelectedMovie('');
//     setValidityFrom('');
//     setValidityUntil('');
//     setShowtimes([{ hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }]);
//     setSubmitted(false);
//     setIsReadyForBooking(false);
//   };

//   // const DatePickerModal = ({ index, onClose, onSave }) => {
//   //   const allDates = getAllDatesInRange();
//   //   const allDatesFormatted = allDates.map(date => formatDate(date));
//   //   const [excludedDates, setExcludedDates] = useState([]);

//   //   // Initialize with dates that are already excluded (if any)
//   //   useEffect(() => {
//   //     if (showtimes[index].enabledDates.length > 0) {
//   //       const excluded = allDatesFormatted.filter(
//   //         date => !showtimes[index].enabledDates.includes(date)
//   //       );
//   //       setExcludedDates(excluded);
//   //     }
//   //   }, [index]);

//   //   const toggleDate = (dateStr) => {
//   //     setExcludedDates(prev => 
//   //       prev.includes(dateStr)
//   //         ? prev.filter(d => d !== dateStr)
//   //         : [...prev, dateStr]
//   //     );
//   //   };

//   //   const getEnabledDates = () => {
//   //     return excludedDates.length > 0 
//   //       ? allDatesFormatted.filter(date => !excludedDates.includes(date))
//   //       : []; // Empty array means all dates are enabled
//   //   };

//   //   return (
//   //     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//   //       <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
//   //         <h3 className="text-lg font-bold mb-4">Exclude Dates</h3>

//   //         <div className="mb-4 p-3 bg-blue-50 rounded-lg">
//   //           <p className="text-sm text-blue-800">
//   //             All dates between {validityFrom} and {validityUntil} are enabled by default.
//   //             <br />
//   //             <span className="font-medium">Check dates you want to exclude.</span>
//   //           </p>
//   //         </div>

//   //         <div className="grid grid-cols-7 gap-2 mb-4">
//   //           {allDates.map((date, idx) => {
//   //             const dateStr = formatDate(date);
//   //             const isExcluded = excludedDates.includes(dateStr);
//   //             return (
//   //               <label 
//   //                 key={idx} 
//   //                 className={`flex flex-col items-center p-2 rounded cursor-pointer ${
//   //                   isExcluded ? 'bg-gray-100' : 'bg-white'
//   //                 }`}
//   //               >
//   //                 <input
//   //                   type="checkbox"
//   //                   checked={isExcluded}
//   //                   onChange={() => toggleDate(dateStr)}
//   //                   className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
//   //                 />
//   //                 <span className={`mt-1 text-center ${isExcluded ? 'text-gray-500' : 'font-medium'}`}>
//   //                   {date.getDate()}
//   //                 </span>
//   //                 <span className="text-xs text-gray-500">
//   //                   {date.toLocaleString('default', { month: 'short' })}
//   //                 </span>
//   //               </label>
//   //             );
//   //           })}
//   //         </div>

//   //         <div className="flex justify-between items-center">
//   //           <span className="text-sm text-gray-500">
//   //             {excludedDates.length > 0 
//   //               ? `Excluding ${excludedDates.length} dates` 
//   //               : 'All dates are enabled'}
//   //           </span>
//   //           <div className="flex gap-2">
//   //             <button 
//   //               onClick={onClose}
//   //               className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
//   //             >
//   //               Cancel
//   //             </button>
//   //             <button 
//   //               onClick={() => onSave(getEnabledDates())}
//   //               className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//   //             >
//   //               Save Exclusions
//   //             </button>
//   //           </div>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );
//   // };












//   const DatePickerModal = ({ index, onClose, onSave }) => {
//     const allDates = getAllDatesInRange();
//     const allDatesFormatted = allDates.map(date => formatDate(date));

//     // Initialize with all dates selected by default
//     const [selectedDates, setSelectedDates] = useState([...allDatesFormatted]);

//     // If enabledDates has values, use them (for editing existing selections)
//     useEffect(() => {
//       if (showtimes[index].enabledDates.length > 0) {
//         setSelectedDates(showtimes[index].enabledDates);
//       }
//     }, [index]);

//     const toggleDate = (dateStr) => {
//       setSelectedDates(prev => 
//         prev.includes(dateStr)
//           ? prev.filter(d => d !== dateStr)
//           : [...prev, dateStr]
//       );
//     };

//     return (
//       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//         <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
//           <h3 className="text-lg font-bold mb-4">Select Enabled Dates</h3>

//           <div className="mb-4 p-3 bg-blue-50 rounded-lg">
//             <p className="text-sm text-blue-800">
//               All dates are <span className="font-bold">selected</span> by default.
//               <br />
//               <span className="font-medium">Uncheck dates you want to disable.</span>
//             </p>
//           </div>

//           <div className="grid grid-cols-7 gap-2 mb-4">
//             {allDates.map((date, idx) => {
//               const dateStr = formatDate(date);
//               const isSelected = selectedDates.includes(dateStr);
//               return (
//                 <label 
//                   key={idx} 
//                   className={`flex flex-col items-center p-2 rounded cursor-pointer ${
//                     isSelected ? 'bg-white' : 'bg-gray-100'
//                   }`}
//                 >
//                   <input
//                     type="checkbox"
//                     checked={isSelected}
//                     onChange={() => toggleDate(dateStr)}
//                     className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
//                   />
//                   <span className={`mt-1 text-center ${isSelected ? 'font-medium' : 'text-gray-500'}`}>
//                     {date.getDate()}
//                   </span>
//                   <span className="text-xs text-gray-500">
//                     {date.toLocaleString('default', { month: 'short' })}
//                   </span>
//                 </label>
//               );
//             })}
//           </div>

//           <div className="flex justify-between items-center">
//             <span className="text-sm text-gray-500">
//               {selectedDates.length === allDates.length 
//                 ? 'All dates are enabled' 
//                 : `Enabled ${selectedDates.length} of ${allDates.length} dates`}
//             </span>
//             <div className="flex gap-2">
//               <button 
//                 onClick={onClose}
//                 className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
//               >
//                 Cancel
//               </button>
//               <button 
//                 onClick={() => onSave(selectedDates)}
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//               >
//                 Save Selection
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };




//   return (
//     <div className="min-h-screen p-6 max-w-4xl mx-auto">
//       <h1 className="text-2xl font-bold mb-6">Set Movie Validity Schedule</h1>

//       <form onSubmit={handleSubmit} className="space-y-6">
//         {/* Theatre and Movie Selection */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Theatre</label>
//             <select
//               value={selectedTheatre}
//               onChange={handleTheatreChange}
//               disabled={isTicketAdmin}
//               required
//               className="w-full p-2 border rounded-md"
//             >
//               {isTicketAdmin ? (
//                 <option value={theatres[0]?.name}>{theatres[0]?.name}</option>
//               ) : (
//                 <>
//                   <option value="">Select Theatre</option>
//                   {theatres.map(t => (
//                     <option key={t._id} value={t.name}>{t.name}</option>
//                   ))}
//                 </>
//               )}
//             </select>
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700">Movie</label>
//             {isLoadingMovies ? (
//               <div className="p-2 border rounded-md bg-gray-100 text-gray-500">Loading movies...</div>
//             ) : (
//               <select
//                 value={selectedMovie}
//                 onChange={(e) => setSelectedMovie(e.target.value)}
//                 disabled={!selectedTheatre}
//                 required
//                 className="w-full p-2 border rounded-md"
//               >
//                 <option value="">Select Movie</option>
//                 {filteredMovies.map(m => (
//                   <option key={m._id} value={m.name}>{m.name}</option>
//                 ))}
//               </select>
//             )}
//           </div>
//         </div>

//         {/* Validity Dates */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700">From</label>
//             <input
//               type="date"
//               value={validityFrom}
//               onChange={(e) => setValidityFrom(e.target.value)}
//               required
//               className="w-full p-2 border rounded-md"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Until</label>
//             <input
//               type="date"
//               value={validityUntil}
//               onChange={(e) => setValidityUntil(e.target.value)}
//               required
//               className="w-full p-2 border rounded-md"
//             />
//           </div>
//         </div>

//         {/* Showtimes */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-2">Show Times</label>
//           {showtimes.map((s, index) => (
//             <div key={index} className="flex flex-wrap items-center gap-2 mb-3">
//               {["hour", "minute", "period", "language", "format"].map((field) => (
//                 <select
//                   key={field}
//                   name={field}
//                   value={s[field]}
//                   onChange={(e) => handleShowtimeChange(index, e)}
//                   required
//                   className="p-2 border rounded-md"
//                 >
//                   <option value="">{field[0].toUpperCase() + field.slice(1)}</option>
//                   {field === "hour" && [...Array(12).keys()].map(i => (
//                     <option key={i} value={String(i + 1).padStart(2, '0')}>{String(i + 1).padStart(2, '0')}</option>
//                   ))}
//                   {field === "minute" && [...Array(60).keys()].map(i => (
//                     <option key={i} value={String(i).padStart(2, '0')}>{String(i).padStart(2, '0')}</option>
//                   ))}
//                   {field === "period" && ["AM", "PM"].map(p => <option key={p} value={p}>{p}</option>)}
//                   {field === "language" && selectedMovieLanguages.map(l => <option key={l} value={l}>{l}</option>)}
//                   {field === "format" && ["2D", "3D"].map(f => <option key={f} value={f}>{f}</option>)}
//                 </select>
//               ))}

//               {/* Date Selection Button */}
//               {/* <div className="flex flex-col">
//                 <button
//                   type="button"
//                   onClick={() => setDatePickerOpen(index)}
//                   className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200"
//                   style={{ width: '240px' }}
//                 >
//                   {s.enabledDates.length === 0 
//                     ? 'All dates enabled' 
//                     : `${s.enabledDates.length} dates excluded`}
//                 </button>
//                 <small className="text-gray-500">
//                   {s.enabledDates.length > 0 
//                     ? `Excluding: ${s.enabledDates.join(', ')}`
//                     : 'Click to exclude specific dates'}
//                 </small>
//               </div> */}

// <div className="flex flex-col">
//             <button
//               type="button"
//               onClick={() => setDatePickerOpen(index)}
//               className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200"
//               style={{ width: '240px' }}
//             >
//               {s.enabledDates.length === getAllDatesInRange().length || s.enabledDates.length === 0
//                 ? 'All dates enabled'
//                 : `${s.enabledDates.length} dates enabled`}
//             </button>
//             <small className="text-gray-500">
//               {s.enabledDates.length === getAllDatesInRange().length || s.enabledDates.length === 0
//                 ? 'Click to modify enabled dates'
//                 : `Enabled: ${s.enabledDates.join(', ')}`}
//             </small>
//           </div>

//               {/* Add/Remove Showtime Buttons */}
//               <button
//                 type="button"
//                 onClick={() => index === 0 ? addShowtime() : removeShowtime(index)}
//                 className={`p-2 text-white rounded-md ${index === 0 ? 'bg-green-600' : 'bg-red-600'}`}
//               >
//                 {index === 0 ? '+' : '-'}
//               </button>
//             </div>
//           ))}
//         </div>

//         {/* Ready for Booking */}
//         <div className="flex items-center">
//           <input
//             type="checkbox"
//             checked={isReadyForBooking}
//             onChange={(e) => setIsReadyForBooking(e.target.checked)}
//             className="mr-2"
//           />
//           <label>Ready for Booking Immediately</label>
//         </div>

//         {/* Submit Button */}
//         <button
//           type="submit"
//           disabled={submitted}
//           className={`w-full py-2 text-white rounded-md ${submitted ? 'bg-gray-400' : 'bg-black hover:bg-gray-800'}`}
//         >
//           {submitted ? 'Submitting...' : 'Submit Schedule'}
//         </button>
//       </form>

//       {/* Date Picker Modal */}
//       {datePickerOpen !== null && (
//         <DatePickerModal
//           index={datePickerOpen}
//           onClose={() => setDatePickerOpen(null)}
//           onSave={(dates) => {
//             handleDateSelection(datePickerOpen, dates);
//             setDatePickerOpen(null);
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default AddValidity;











const AddValidity = () => {
  const [theatres, setTheatres] = useState([]);
  const [filteredMovies, setFilteredMovies] = useState([]);
  const [selectedTheatre, setSelectedTheatre] = useState('');
  const [selectedMovie, setSelectedMovie] = useState('');
  const [selectedMovieLanguages, setSelectedMovieLanguages] = useState([]);
  const [validityFrom, setValidityFrom] = useState('');
  const [validityUntil, setValidityUntil] = useState('');
  const [showtimes, setShowtimes] = useState([
    { hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }
  ]);
  const [isReadyForBooking, setIsReadyForBooking] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isLoadingMovies, setIsLoadingMovies] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState(null);

  const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
  const isTicketAdmin = role === 'ticket-admin';

  useEffect(() => {
    const fetchTheatres = async () => {
      try {
        const theatresRes = await TheatreServices.getTheatres();
        let filtered = theatresRes;
        if (isTicketAdmin) {
          filtered = theatresRes.filter(t => accessList.includes(t.name));
        }
        setTheatres(filtered);

        if (filtered.length > 0) {
          const defaultTheatre = filtered[0];
          setSelectedTheatre(defaultTheatre.name);
          handleTheatreChangeById(defaultTheatre._id);
        }
      } catch (err) {
        console.error("Error fetching theatres:", err);
      }
    };
    fetchTheatres();
  }, []);

  const handleTheatreChange = (e) => {
    const theatreName = e.target.value;
    setSelectedTheatre(theatreName);
    setSelectedMovie('');
    setSelectedMovieLanguages([]);
    const theatreId = theatres.find(t => t.name === theatreName)?._id;
    if (theatreId) handleTheatreChangeById(theatreId);
  };

  const handleTheatreChangeById = async (theatreId) => {
    try {
      setIsLoadingMovies(true);
      const res = await MovieServices.getMovieByTheaterId(theatreId);
      setFilteredMovies(res || []);
    } catch (err) {
      console.error("Error fetching movies:", err);
      setFilteredMovies([]);
    } finally {
      setIsLoadingMovies(false);
    }
  };

  useEffect(() => {
    if (!selectedMovie || filteredMovies.length === 0) return;
    const selected = filteredMovies.find(movie => movie.name === selectedMovie);
    setSelectedMovieLanguages(
      selected?.movieLanguages || ["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"]
    );
  }, [selectedMovie, filteredMovies]);

  const handleShowtimeChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...showtimes];
    updated[index][name] = value;
    setShowtimes(updated);
  };

  const addShowtime = () => {
    setShowtimes([...showtimes, { hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }]);
  };

  const removeShowtime = (index) => {
    const updated = showtimes.filter((_, i) => i !== index);
    setShowtimes(updated);
  };

  const handleDateSelection = (index, dates) => {
    const updated = [...showtimes];
    updated[index].enabledDates = dates;
    setShowtimes(updated);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  const getAllDatesInRange = () => {
    if (!validityFrom || !validityUntil) return [];

    const start = new Date(validityFrom);
    const end = new Date(validityUntil);
    const dates = [];

    let current = new Date(start);
    while (current <= end) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }

    return dates;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setSubmitted(true);

  //   // Get all dates in range
  //   const allDates = getAllDatesInRange();
  //   const allDatesFormatted = allDates.map(date => formatDate(date));

  //   const data = {
  //     movieName: selectedMovie,
  //     validityFrom: new Date(validityFrom).toISOString(),
  //     validityUntil: new Date(validityUntil).toISOString(),
  //     theatreShowtimes: [
  //       {
  //         theatreName: selectedTheatre,
  //         isReadyForBooking,
  //         shows: showtimes.map(({ hour, minute, period, language, format, enabledDates }) => ({
  //           time: `${hour}:${minute} ${period}`,
  //           language,
  //           format,
  //           enabledDates: enabledDates.length === 0 ? allDatesFormatted : enabledDates
  //         }))
  //       }
  //     ]
  //   };

  //   try {
  //     const response = await showTimeServices.createShowtime(data);
  //     if (response?.data) {
  //       alert('✅ Successfully added showtime');
  //       resetForm();
  //     } else {
  //       handleError(response);
  //     }
  //   } catch (err) {
  //     console.error("Submit error:", err);
  //     alert('❌ Something went wrong!');
  //     resetForm();
  //   }
  // };










  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
  
    // Get all dates in range
    const allDates = getAllDatesInRange();
    const allDatesFormatted = allDates.map(date => formatDate(date));
  
    // Create shows array and sort by time
    const sortedShows = showtimes
      .map(({ hour, minute, period, language, format, enabledDates }) => ({
        time: `${hour}:${minute} ${period}`,
        language,
        format,
        enabledDates: enabledDates.length === 0 ? allDatesFormatted : enabledDates
      }))
      .sort((a, b) => {
        // Convert to comparable format: convert to 24-hour then compare
        const convertTo24Hour = (time12h) => {
          const [time, modifier] = time12h.split(' ');
          let [hours, minutes] = time.split(':');
          if (hours === '12') hours = '00';
          if (modifier === 'PM') hours = parseInt(hours, 10) + 12;
          return `${hours.toString().padStart(2, '0')}:${minutes}`;
        };
        
        const timeA = convertTo24Hour(a.time);
        const timeB = convertTo24Hour(b.time);
        
        return timeA.localeCompare(timeB);
      });
  
    const data = {
      movieName: selectedMovie,
      validityFrom: new Date(validityFrom).toISOString(),
      validityUntil: new Date(validityUntil).toISOString(),
      theatreShowtimes: [
        {
          theatreName: selectedTheatre,
          isReadyForBooking,
          shows: sortedShows
        }
      ]
    };
  
    try {
      const response = await showTimeServices.createShowtime(data);
      if (response?.data) {
        alert('✅ Successfully added showtime');
        resetForm();
      } else {
        handleError(response);
      }
    } catch (err) {
      console.error("Submit error:", err);
      alert('❌ Something went wrong!');
      resetForm();
    }
  };
  

  const handleError = (response) => {
    const msg = response.error?.message || response.message || response.error;
    if (msg.includes('cannot be booked today')) {
      const match = msg.match(/valid (.*?) to (.*?)\)/);
      if (match) {
        alert(`⚠️ Can only be booked between ${match[1]} and ${match[2]}`);
      } else alert(msg);
    } else if (msg.includes('Showtime already exists')) {
      const nameMatch = msg.match(/movie \\"(.+?)\\"/);
      alert(`❌ Showtime already exists for ${nameMatch?.[1] || 'this movie'}`);
    } else alert("❌ " + msg);
    resetForm();
  };

  const resetForm = () => {
    setSelectedMovie('');
    setValidityFrom('');
    setValidityUntil('');
    setShowtimes([{ hour: '', minute: '', period: '', language: '', format: '', enabledDates: [] }]);
    setSubmitted(false);
    setIsReadyForBooking(false);
  };

  const DatePickerModal = ({ index, onClose, onSave }) => {
    const allDates = getAllDatesInRange();
    const allDatesFormatted = allDates.map(date => formatDate(date));

    // Initialize with all dates selected by default
    const [selectedDates, setSelectedDates] = useState([...allDatesFormatted]);

    // If enabledDates has values, use them (for editing existing selections)
    useEffect(() => {
      if (showtimes[index].enabledDates.length > 0) {
        setSelectedDates(showtimes[index].enabledDates);
      }
    }, [index]);

    const toggleDate = (dateStr) => {
      setSelectedDates(prev =>
        prev.includes(dateStr)
          ? prev.filter(d => d !== dateStr)
          : [...prev, dateStr]
      );
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
          <h3 className="text-lg font-bold mb-4">Select Enabled Dates</h3>

          <div className="mb-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              All dates are <span className="font-bold">enabled</span> by default.
              <br />
              <span className="font-medium">Uncheck dates you want to disable.</span>
            </p>
          </div>

          <div className="grid grid-cols-7 gap-2 mb-4">
            {allDates.map((date, idx) => {
              const dateStr = formatDate(date);
              const isSelected = selectedDates.includes(dateStr);
              return (
                <label
                  key={idx}
                  className={`flex flex-col items-center p-2 rounded cursor-pointer ${isSelected ? 'bg-white' : 'bg-gray-100'
                    }`}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggleDate(dateStr)}
                    className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                  />
                  <span className={`mt-1 text-center ${isSelected ? 'font-medium' : 'text-gray-500'}`}>
                    {date.getDate()}
                  </span>
                  <span className="text-xs text-gray-500">
                    {date.toLocaleString('default', { month: 'short' })}
                  </span>
                </label>
              );
            })}
          </div>

          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-500">
              {selectedDates.length === allDates.length
                ? 'All dates are enabled'
                : `Enabled ${selectedDates.length} of ${allDates.length} dates`}
            </span>
            <div className="flex gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={() => onSave(selectedDates)}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save Selection
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Set Movie Validity Schedule</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Theatre and Movie Selection */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Theatre</label>
            <select
              value={selectedTheatre}
              onChange={handleTheatreChange}
              disabled={isTicketAdmin}
              required
              className="w-full p-2 border rounded-md"
            >
              {isTicketAdmin ? (
                <option value={theatres[0]?.name}>{theatres[0]?.name}</option>
              ) : (
                <>
                  <option value="">Select Theatre</option>
                  {theatres.map(t => (
                    <option key={t._id} value={t.name}>{t.name}</option>
                  ))}
                </>
              )}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Movie</label>
            {isLoadingMovies ? (
              <div className="p-2 border rounded-md bg-gray-100 text-gray-500">Loading movies...</div>
            ) : (
              <select
                value={selectedMovie}
                onChange={(e) => setSelectedMovie(e.target.value)}
                disabled={!selectedTheatre}
                required
                className="w-full p-2 border rounded-md"
              >
                <option value="">Select Movie</option>
                {filteredMovies.map(m => (
                  <option key={m._id} value={m.name}>{m.name}</option>
                ))}
              </select>
            )}
          </div>
        </div>

        {/* Validity Dates */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">From</label>
            <input
              type="date"
              value={validityFrom}
              onChange={(e) => setValidityFrom(e.target.value)}
              required
              className="w-full p-2 border rounded-md"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Until</label>
            <input
              type="date"
              value={validityUntil}
              onChange={(e) => setValidityUntil(e.target.value)}
              required
              className="w-full p-2 border rounded-md"
            />
          </div>
        </div>

        {/* Showtimes */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Show Times</label>
          {showtimes.map((s, index) => {
            const allDates = getAllDatesInRange();
            return (
              <div key={index} className="flex flex-wrap items-center gap-2 mb-3">
                {["hour", "minute", "period", "language", "format"].map((field) => (
                  <select
                    key={field}
                    name={field}
                    value={s[field]}
                    onChange={(e) => handleShowtimeChange(index, e)}
                    required
                    className="p-2 border rounded-md"
                  >
                    <option value="">{field[0].toUpperCase() + field.slice(1)}</option>
                    {field === "hour" && [...Array(12).keys()].map(i => (
                      <option key={i} value={String(i + 1).padStart(2, '0')}>{String(i + 1).padStart(2, '0')}</option>
                    ))}
                    {field === "minute" && [...Array(60).keys()].map(i => (
                      <option key={i} value={String(i).padStart(2, '0')}>{String(i).padStart(2, '0')}</option>
                    ))}
                    {field === "period" && ["AM", "PM"].map(p => <option key={p} value={p}>{p}</option>)}
                    {field === "language" && selectedMovieLanguages.map(l => <option key={l} value={l}>{l}</option>)}
                    {field === "format" && ["2D", "3D"].map(f => <option key={f} value={f}>{f}</option>)}
                  </select>
                ))}

                {/* Date Selection Button */}
                {/* <div className="flex flex-col">
                  <button
                    type="button"
                    onClick={() => setDatePickerOpen(index)}
                    className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200"
                    style={{ width: '240px' }}
                  >
                    {s.enabledDates.length === 0 || s.enabledDates.length === allDates.length
                      ? 'All dates enabled'
                      : `${s.enabledDates.length} dates enabled`}
                  </button>
                  <small className="text-gray-500">
                    {s.enabledDates.length === 0 || s.enabledDates.length === allDates.length
                      ? 'Click to modify enabled dates'
                      : `Enabled: ${s.enabledDates.join(', ')}`}
                  </small>
                </div> */}







                {/* Date Selection Button with Tooltip - Always show tooltip */}
                <div className="relative group">
                  <button
                    type="button"
                    onClick={() => setDatePickerOpen(index)}
                    className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200"
                    style={{ width: '240px' }}
                  >
                    {s.enabledDates.length === 0 || s.enabledDates.length === allDates.length
                      ? 'All dates enabled'
                      : `${s.enabledDates.length} dates enabled`}
                  </button>

                  {/* Tooltip - shows for all cases */}
                  <div className="absolute left-0 top-full mt-1 z-10 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 w-64 whitespace-normal break-words">
                    {s.enabledDates.length === 0 || s.enabledDates.length === allDates.length
                      ? allDates.map(date => moment(formatDate(date)).format('DD-MM-YYYY')).join(', ')
                      : s.enabledDates.map(date => moment(date).format('DD-MM-YYYY')).join(', ')
                    }
                  </div>
                </div>


                {/* Add/Remove Showtime Buttons */}
                <button
                  type="button"
                  onClick={() => index === 0 ? addShowtime() : removeShowtime(index)}
                  className={`p-2 text-white rounded-md ${index === 0 ? 'bg-green-600' : 'bg-red-600'}`}
                >
                  {index === 0 ? '+' : '-'}
                </button>
              </div>
            );
          })}
        </div>

        {/* Ready for Booking */}
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={isReadyForBooking}
            onChange={(e) => setIsReadyForBooking(e.target.checked)}
            className="mr-2"
          />
          <label>Ready for Booking Immediately</label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={submitted}
          className={`w-full py-2 text-white rounded-md ${submitted ? 'bg-gray-400' : 'bg-black hover:bg-gray-800'}`}
        >
          {submitted ? 'Submitting...' : 'Submit Schedule'}
        </button>
      </form>

      {/* Date Picker Modal */}
      {datePickerOpen !== null && (
        <DatePickerModal
          index={datePickerOpen}
          onClose={() => setDatePickerOpen(null)}
          onSave={(dates) => {
            handleDateSelection(datePickerOpen, dates);
            setDatePickerOpen(null);
          }}
        />
      )}
    </div>
  );
};

export default AddValidity;
